import api from './api';
import { DeliveryCharge, DeliveryChargeResponse, SingleDeliveryChargeResponse } from '../types/deliveryCharge';

export const getDeliveryCharges = async (): Promise<DeliveryChargeResponse> => {
    const response = await api.get('/delivery-charges');
    return response.data;
};

export const getDeliveryChargeById = async (id: string): Promise<SingleDeliveryChargeResponse> => {
    const response = await api.get(`/delivery-charges/${id}`);
    return response.data;
};

export const createDeliveryCharge = async (payload: Omit<DeliveryCharge, 'id' | 'createdAt' | 'updatedAt'>): Promise<SingleDeliveryChargeResponse> => {
    const response = await api.post('/delivery-charges', payload);
    return response.data;
};

export const updateDeliveryCharge = async (id: string, payload: Partial<Omit<DeliveryCharge, 'id' | 'createdAt' | 'updatedAt'>>): Promise<SingleDeliveryChargeResponse> => {
    const response = await api.put(`/delivery-charges/${id}`, payload);
    return response.data;
};

export const toggleDeliveryCharge = async (id: string): Promise<SingleDeliveryChargeResponse> => {
    const response = await api.patch(`/delivery-charges/${id}/toggle`);
    return response.data;
};

export const deleteDeliveryCharge = async (id: string): Promise<{ success: boolean; message: string }> => {
    const response = await api.delete(`/delivery-charges/${id}`);
    return response.data;
};
